import type { QueryClient } from "@tanstack/react-query";

/**
 * The app's React Query cache, registered by main.tsx, so the auth store can
 * drop it when the signed-in user changes (see switchUserScope) — a key that
 * forgot its userId would otherwise show one account's data to the next.
 *
 * Registered rather than constructed here: the auth store is imported almost
 * everywhere, and building a client at its import would break every test that
 * mocks @tanstack/react-query.
 */
let appQueryClient: QueryClient | null = null;

export function registerQueryClient(client: QueryClient): void {
  appQueryClient = client;
}

/** Removes every cached query. A no-op until a client is registered. */
export function clearQueryCache(): void {
  appQueryClient?.clear();
}
